import { useMutation, useQueryClient } from '@tanstack/react-query';
import { outfitService } from 'shared/src/api';
import { queryKey } from '../../../../../constant/queryKey';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';

export const useLikeOutfit = () => {
  const queryClient = useQueryClient();
  const goodsSno = useGoodsSno();

  return useMutation({
    mutationFn: ({ sno, liked }: { sno: number; liked: boolean }) =>
      liked ? outfitService.removeLike(sno) : outfitService.postLike(sno),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey.goodsRelatedOutfit(goodsSno),
      });
    },
  });
};
